<template>
  <div :class="['header', { transparent: transparent, minimal: minimal }]">
    <router-link :to="{ name: 'home' }" class="go-home-link">
      <img v-if="!transparent" src="~@/assets/images/logo.png" alt="Dufry" />
    </router-link>
    <div class="header-menu">
      <template v-if="!minimal">
        <router-link v-if="byConceptsAvailable" class="link option" :to="{ name: RouteNames.ExploreByConcepts }">
          <span class="text">{{ t("explore_by") }} {{ t("explore_by_concepts") }}</span>
        </router-link>
        <router-link class="link option" :to="{ name: RouteNames.ExploreByFamilies }">
          <span class="text">{{ t("explore_by") }} {{ t("explore_by_families") }}</span>
        </router-link>
      </template>
    </div>
    <div class="burger" v-if="minimal && langs.length > 1">
      <span class="lang" :class="{ open: burgerPopupVisible }" @click="burgerPopupVisible = !burgerPopupVisible">{{
        langText }}</span>
      <transition name="burger-fade">
        <div class="burger-dropdown" v-if="burgerPopupVisible">
          <div class="burger-group">
            <div class="burger-content">
              <ButtonWithFeedback v-for="lang in langs" :key="lang.value" class="lang-btn"
                :class="currentLang === lang.value ? 'selected' : ''" @click="setLang(lang.value)">
                <div class="icon"></div>
                <div class="label">{{ lang.label }}</div>
              </ButtonWithFeedback>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ButtonWithFeedback from "@/components/ButtonWithFeedback";
import { RouteNames } from "../router";
import Languages from "../vue-plugins/Languages";
export default {
  name: "Header",
  props: ["transparent", "minimal"],
  // mounted () {
  //   console.log(this.atelier)
  // },
  components: {
    ButtonWithFeedback,
  },
  mixins: [Languages],
  data() {
    return {
      RouteNames,
      popupVisible: false,
      currentExplore: this.getCurrentExplore(),
      openMenu: false,
      burgerPopupVisible: false,
    };
  },
  routerLinkedData: ["openMenu"],
  mounted() {
    window.addEventListener("click", this.onWindowClick);
  },
  destroy() {
    window.removeEventListener("click", this.onWindowClick);
  },
  computed: {
    langText() {
      return this.langs.find(lang => lang.value === this.currentLang)?.label.slice(0, 3).toUpperCase()
    },
    currentLang() {
      return this.lang
    },
    instagramURL() {
      return process.env.VUE_APP_INSTAGRAM;
    },
    showNotification() {
      return (
        this.$store.state.appState.pendingView &&
        this.$router.currentRoute.name !== "profile"
      );
    },
    byConceptsAvailable() {
      return true;
      // return this.$store.state.i18n.lang === 'en'
    }
  },
  methods: {
    setLang(lang) {
      this.lang = lang
      this.$emit("change");
    },
    getCurrentExplore() {
      if (
        this.$router.currentRoute.name &&
        this.$router.currentRoute.name.indexOf("explore") >= 0
      ) {
        return this.$router.currentRoute;
      } else {
        return null;
      }
    },
    dismissNotification() {
      this.$store.dispatch("setViewed", true);
    },
    onWindowClick(e) {
      if (!e.target.closest(".burger")) this.burgerPopupVisible = false;
    },
  },
  watch: {
    $route() {
      if (this.$router.currentRoute.name === "profile")
        this.dismissNotification();
      this.currentExplore = this.getCurrentExplore();
      this.popupVisible = false;
      this.burgerPopupVisible = false;
    },
  },
};
</script>

<style scoped lang="stylus">
$logo-width = vw(170px)

.header
  position: relative
  display: flex
  justify-content: space-between
  align-items: center
  padding-right: vw(50px)
  padding-left: vw(50px)
  height: $header-height
  background-color: #fff
  transition background-color .5s ease

  .mobile &
    flex: 0 0 $header-height-mobile
    height: $header-height-mobile

  &.transparent,
  &.minimal
    background-color transparent

  .go-home-link
    display: flex
    align-items: center
    padding: vh(2px) 0
    height: 100%

    img
      height: vw(36px)

  .header-menu
    position: absolute
    left: 50%
    display: flex
    align-items: center
    height: $header-height
    transform: translateX(-50%)
    gap: vw(20px)

    .link
      display: flex
      justify-content: center
      align-items: center
      padding-right: vw(40px)
      padding-left: vw(40px)
      height: 100%
      cursor: pointer

      &[class*="active"]
        position: relative

        &:after
          position: absolute
          bottom: 1px
          left: 0
          width: 100%
          height: 2px
          background-color: $golden
          content: ""

        .text
          color: #000

      .text
        m-font-size(14, 20)
        m-letter-spacing(20)
        display: flex
        justify-content: center
        align-items: center
        height: 100%
        color: $golden

  .burger
    position: relative
    cursor: pointer

    .lang
      m-font-size(14, 20)
      position: relative
      padding-right: vw(30px)
      color: $golden
      font-weight: 600

      &.open
        &:after
          transform: rotate(0) translateY(-50%)

      &:after
        m-icon("chevron-down", 20)
        position: absolute
        top: 50%
        right: 0
        content: ""
        transition: 0.25s transform ease-in-out
        transform: rotate(180deg) translateY(-50%)
        transform-origin: top

    .burger-dropdown
      position: absolute
      top: calc(100% + 10px)
      right: 0
      z-index: 2
      display: flex
      flex-direction: column
      padding: vw(20px)
      border: 1px solid rgba(#000, 0.15)
      background-color: #fff

      &:before
        m-triangle("up", rgba(#000, 0.15), 10 8)
        top: vh(-10px)
        right: 1px

      &:after
        m-triangle("up", #fff, 10 8)
        top: vh(-9px)
        right: 1px

      &.burger-fade-enter-active,
      &.burger-fade-leave-active
        transition: opacity 0.4s

      &.burger-fade-enter,
      &.burger-fade-leave-to
        opacity: 0

  // poso el css fora del "burger-dropdown" xk serveixi pel mobile tb
  // tot i que shauran de posar ".mobile &" o similars
  .burger-group
    &:not(:last-child)
      margin-bottom: vw(20px)
      padding-bottom: vw(20px)
      border-bottom: 1px solid rgba(#000, 0.15)

  .burger-title
    m-font-size(10, 14)
    m-letter-spacing(15)
    margin-bottom: vh(5vh)
    color: rgba(#000, 0.15)

    .mobile &
      m-font-size(14, 16)
      margin-bottom: vh(20px)

  .burger-content
    m-font-size(14, 20)

    .mobile &
      m-font-size(20, 30)
      margin: 0 vw(20px)

    >>> .link
      .mobile &
        justify-content: flex-start

    .lang-btn
      &:not(:last-child)
        margin-bottom: vw(10px)

  .notification
    $notification-height = vh(40px)
    $notification-height-out = vh(-40px)
    m-font-size(14, 22)
    position: absolute
    top: 100%
    z-index: 1
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    height: $notification-height
    background-color: #000
    color: #fff
    text-align: center

    .mobile &
      $notification-height = vh(80px)
      $notification-height-out = vh(-80px)
      height: $notification-height

      &.slide-enter,
      &.slide-leave-to /* .drop-down-leave-active below version 2.1.8 */
        transform: translate(0, $notification-height-out)

    &.slide-enter-active,
    &.slide-leave-active
      transition: transform 0.2s

    &.slide-enter,
    &.slide-leave-to /* .drop-down-leave-active below version 2.1.8 */
      transform: translate(0, $notification-height-out)

    .content
      m-font-size(14, 16)
      flex: 1 1 0%
      padding: vh(5px) vw(5px)

      .mobile &
        m-font-size(12, 14)

      .link
        text-decoration: underline
</style>